// extracted by mini-css-extract-plugin
export default {"titleStatistics":"Form_titleStatistics__Gll7V"};